/**
 * KAN-756: раздел CRM интернет-магазина.
 * KAN-758: без min-h-screen: страница не прокручивается, прокрутка внутри таблицы.
 * KAN-862: переключатель "Таблица | Доска" (?view=, без него узкий экран
 * открывает доску). Таблица с периодом и фильтрами: CrmTableSection; доска:
 * панель BoardToolbar и канбан CrmKanbanBoard, карточка ведёт в /clients/<id>.
 * KAN-865: доска целиком в CrmBoardSection: клик по карточке открывает панель
 * карточки клиента (?card=<id>), фильтр "Требуют внимания" (?attention=1).
 * KAN-883: третий вид "Лиды по дням" (?view=stats) - CrmStatsSection.
 * KAN-910: вид по умолчанию (по ширине экрана) пишется в адрес: ссылка открывает тот же вид.
 */
import { useEffect } from 'react';
import { PageLayout } from '@/components/layout/PageLayout';
import { CrmTableSection } from '@/components/crm/CrmTableSection';
import { CrmBoardSection } from '@/components/crm/board/CrmBoardSection';
import { CrmStatsSection } from '@/components/crm/stats/CrmStatsSection';
import { SegmentedControl } from '@/components/crm/board/SegmentedControl';
import { useCrmBoardView, useCrmPageDefaults } from '@/hooks/useCrmBoardView';
import type { CrmView } from '@/lib/crmPipeline';
import type { CrmPipelineCard } from '@/types/crmPipeline';

const VIEW_OPTIONS: readonly { value: CrmView; label: string }[] = [
  { value: 'table', label: 'Таблица' },
  { value: 'board', label: 'Доска' },
  { value: 'stats', label: 'Лиды по дням' },
];

const clientHref = (card: CrmPipelineCard) => `/clients/${card.id}`;
const companyHref = (companyId: string) => `/companies/${companyId}`;

export function CrmPage(): JSX.Element {
  const board = useCrmBoardView();
  useCrmPageDefaults(board.defaultView);

  useEffect(() => {
    document.title = 'CRM - SMETA AI';
  }, []);

  const toggle = (
    <SegmentedControl
      label="Вид"
      options={VIEW_OPTIONS}
      value={board.view}
      onChange={board.setView}
      testId="crm-view-toggle"
    />
  );

  return (
    <PageLayout title="CRM" breadcrumbs={[{ label: 'CRM' }]} maxWidth="max-w-none" fillScreen={false} data-testid="crm-page">
      <div className="min-w-0 space-y-3">
        {board.view === 'table' && <CrmTableSection leading={toggle} />}
        {board.view === 'stats' && <CrmStatsSection leading={toggle} />}
        {board.view === 'board' && (
          <CrmBoardSection
            leading={toggle}
            variant={board.narrow ? 'mobile' : 'desktop'}
            clientHref={clientHref}
            companyHref={companyHref}
          />
        )}
      </div>
    </PageLayout>
  );
}

export default CrmPage;
